import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1029f6c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-section category-list" }
const _hoisted_2 = { class: "category-list-category" }
const _hoisted_3 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_4 = { class: "mt-2 mb-4" }
const _hoisted_5 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBarMenu = _resolveComponent("SideBarMenu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SideBarMenu, {
      class: "content-section",
      categories: _ctx.categories,
      title: _ctx.title,
      onComponentSelected: _ctx.onMenu_ComponentSelected
    }, null, 8, ["categories", "title", "onComponentSelected"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (cat) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (cat.title?.length > 0)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(cat.title), 1))
            : _createCommentVNode("", true),
          _createElementVNode("ol", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLibraryComponents(cat), (comp) => {
              return (_openBlock(), _createElementBlock("li", _hoisted_4, [
                (comp.title?.length > 0)
                  ? (_openBlock(), _createElementBlock("h3", {
                      key: 0,
                      id: _ctx.getComponentId(comp.id),
                      ref_for: true,
                      ref: _ctx.getComponentId(comp.id)
                    }, _toDisplayString(comp.title), 9, _hoisted_5))
                  : _createCommentVNode("", true),
                (_openBlock(), _createBlock(_resolveDynamicComponent(comp.libraryComponent)))
              ]))
            }), 256))
          ])
        ]))
      }), 256))
    ])
  ], 64))
}